import React from 'react';
import './HireATSection.scss';

const HireATSection = ({ onImReady }) => {
  return (
    <section id="hire-at" className="hire-at-section">
      <h2 className="hire-at-section__title scroll-animate fade-up stagger-1">
        Hire certified, insured Athletic Trainers
      </h2>
      <button className="hire-at-section__button scroll-animate fade-up-bold stagger-2" onClick={onImReady}>
        Get Started
      </button>
    </section>
  );
};

export default HireATSection;
